import type { FilterFieldDef } from 'components/common/MasterFilter/smartFilterTypes';
import { CarTypes, FuelTypes, Transmissions } from 'services/types/car';

const carsFilterFields: FilterFieldDef[] = [
  // ─── Identificación ───
  { backendField: 'id', label: 'ID Relif', type: 'numericRange', group: 'Identificación' },
  { backendField: 'referenceId', label: 'ID Empresa', type: 'textSearch', group: 'Identificación' },
  { backendField: 'licensePlate', label: 'Patente', type: 'textSearch', group: 'Identificación' },

  // ─── Fechas ───
  { backendField: 'createdAt', label: 'Creación', type: 'dateRange', group: 'Fechas' },
  { backendField: 'updatedAt', label: 'Actualización', type: 'dateRange', group: 'Fechas' },

  // ─── Vehículo ───
  { backendField: 'brand', label: 'Marca', type: 'textSearch', group: 'Vehículo' },
  { backendField: 'model', label: 'Modelo', type: 'textSearch', group: 'Vehículo' },
  { backendField: 'version', label: 'Versión', type: 'textSearch', group: 'Vehículo' },
  { backendField: 'year', label: 'Año', type: 'numericRange', group: 'Vehículo' },
  { backendField: 'color', label: 'Color', type: 'textSearch', group: 'Vehículo' },
  {
    backendField: 'carType',
    label: 'Tipo',
    type: 'enum',
    group: 'Vehículo',
    options: CarTypes.map((value) => ({ value, label: value })),
  },
  {
    backendField: 'transmission',
    label: 'Transmisión',
    type: 'enum',
    group: 'Vehículo',
    options: Transmissions.map((value) => ({ value, label: value })),
  },
  {
    backendField: 'fuelType',
    label: 'Combustible',
    type: 'enum',
    group: 'Vehículo',
    options: FuelTypes.map((value) => ({ value, label: value })),
  },

  // ─── Comercial ───
  { backendField: 'price', label: 'Precio', type: 'numericRange', group: 'Comercial' },
  { backendField: 'km', label: 'Kms', type: 'numericRange', group: 'Comercial' },
  {
    backendField: 'isUsed',
    label: 'Tipo venta',
    type: 'enum',
    group: 'Comercial',
    options: [
      { value: 'true', label: 'Usado' },
      { value: 'false', label: 'Nuevo' },
    ],
  },

  // ─── Ubicación ───
  { backendField: 'businessUnit.name', label: 'Unidad de Negocio', type: 'textSearch', group: 'Ubicación' },
  { backendField: 'branchOfficeDirection', label: 'Sucursal', type: 'textSearch', group: 'Ubicación' },

  // ─── Admin-only ───
  { backendField: 'secondaryPrice', label: 'Precio secundario', type: 'numericRange', group: 'Admin' },
  { backendField: 'monthlyFee', label: 'Cuota mensual', type: 'numericRange', group: 'Admin' },
  { backendField: 'category', label: 'Categoría', type: 'textSearch', group: 'Admin' },
];

export default carsFilterFields;
